<template>
  <article class="layout-section -align-side -reverse">
    <figure class="layout-section__figure -reverse" :style="{ backgroundImage }" />

    <section class="layout-section__content">
      <h2 class="layout-section__title">{{ wp.events.title }}</h2>
      <p>
        {{ wp.events.text }}
      </p>

      <RouterLink :to="{ name: 'event-index' }" class="button layout-section__cta">
        Explorez tous les événements
        <SvgIcon id="action-arrow" />
      </RouterLink>
    </section>
  </article>
</template>

<script>
export default {
  name: 'EventsMore',
  inject: ['wp'],
  computed: {
    backgroundImage() {
      return `url(${this.wp.events.image})`
    }
  }
}
</script>
